var React = require('react');

function BurgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.761719","y":"5.15869","width":"15.4762","height":"2.68254","rx":"1.34127","fill":"#6214BE","key":0}),React.createElement("rect",{"x":"0.761719","y":"10.3174","width":"15.4762","height":"2.68254","rx":"1.34127","fill":"#6214BE","key":1}),React.createElement("rect",{"x":"0.761719","width":"15.4762","height":"2.68254","rx":"1.34127","fill":"#6214BE","key":2})]);
}

BurgerMenu.defaultProps = {"width":"17","height":"13","viewBox":"0 0 17 13","fill":"none"};

module.exports = BurgerMenu;

BurgerMenu.default = BurgerMenu;
